import React from 'react';
import './task.css';
import { useDispatch, useSelector } from "react-redux";
import ContextMenu from "../ContextMenu/ContextMenu";
import { contextAction } from "../../redux/rootReducer";
import { archiveTaskSagaAction, getTaskByIdSagaAction, removeTaskSagaAction } from "../../redux/sagaActions";
import { taskStatuses } from "../../helpers/taskStatuses";

const Task = ({ data }) => {
    const dispatch = useDispatch();

    const context = useSelector(state => state.context);
    const task_archive = useSelector(state => state.task_archive);

    const menu = [
        {
            id: '1',
            caption: 'Редактировать',
            handler: () => {
                // Закрываем контекстное меню
                dispatch(contextAction(false));
                // Запрашиваем данные задачи по id и открываем форму
                dispatch(getTaskByIdSagaAction({ task_id: data.id }));
            }
        },
        {
            id: '2',
            caption: task_archive ? 'В текущие' : 'В архив',
            handler: () => {
                // Закрываем контекстное меню
                dispatch(contextAction(false));
                dispatch(archiveTaskSagaAction({ task_id: data.id, archive: task_archive ? '0' : '1' }));
            }
        },
        {
            id: '3',
            caption: 'Удалить',
            handler: () => {
                // Закрываем контекстное меню
                dispatch(contextAction(false));
                // Подтверждение удаления задачи
                if (window.confirm('Вы действительно хотите удалить задачу?')) {
                    dispatch(removeTaskSagaAction({ task_id: data.id }));
                }
            }
        }
    ];

    return(
        <div className="task" style={{ backgroundColor: data.color || '#fff' }}>
            <ContextMenu data={{
                open: data.id === context,
                style: { right: 10, top: 32 },
                menu
            }}/>
            <div className="task__header">
                <div className="task__created">{ `Создано ${ data.datetime }` }</div>
                <div className="task__menu" onClick={ () => dispatch(contextAction(data.id)) }/>
            </div>
            <div className="task__status-wrapper">
                { data.urgent === '1' && <div className="task__urgent"/> }
                <div
                    className={ `task__status task__status--${ task_archive ? 'archive' : data.status }` }
                >{ task_archive ? 'В архиве' : taskStatuses[data.status] }</div>
            </div>
            <div className="task__description">{ data.description }</div>
            <div className="task__meta">
                <div className={ `task__datetime ${ task_archive ? 'task__datetime--archive' : data.past ? 'task__datetime--past' : '' }` }>
                    <div className="task__date">{ data.target_date }</div>
                    <div className="task__time">{ data.target_time }</div>
                </div>
                <div className="task__responsible">{ data.responsible }</div>
            </div>
        </div>
    );
};

export default Task;